import { GA } from '../../../api/channels';
import {
    Wrapper,
    Channel,
} from './styled';

const onLogoClick = (e) => {
    GA({
        action: 'Click_сhannel',
        label: e.title,
    });
};

const PackageChannelList = ({ items }) => {
    return (
        <Wrapper>
            {items && items.map(channel => <Channel logoClick={onLogoClick} group={channel.title} key={channel.chid}  channel={{
                id: channel.chid,
                ...channel,
            }} />) }
        </Wrapper>
    );
};

export default PackageChannelList;
